import React from 'react';
import { useSelector } from 'react-redux';

const LoadingError = () => {
	const error = useSelector(state => state.error);

	return(
		<>Loading Error: {error}</>
	);
}

export default LoadingError;